import { useAppTranslation } from '@flowus/common/i18n';
import { BlockType } from '@next-space/fe-api-idl';
import { useCallback } from 'react';
import { useOpenModal } from 'src/common/components/next-modal';
import { cache } from 'src/redux/store';
import { querySelectorFromMainContent } from 'src/utils/dom';
import { getDynamicPageId, useGetPageId } from 'src/utils/getPageId';

export const useOpenUnSyncDialog = () => {
  const openModal = useOpenModal();
  const pageId = useGetPageId();
  const { t } = useAppTranslation();
  return useCallback(
    (uuid: string, confirm: () => void) => {
      const block = cache.blocks[uuid];
      if (!block) return;
      const isRight = pageId === getDynamicPageId('right');
      const node = querySelectorFromMainContent(`[data-block-id="${uuid}"]`, isRight);
      if (node instanceof HTMLElement) {
        openModal.warning({
          title: <div className="w-[338px]">{t('components.unsync.confirm_unsync')}</div>,
          content:
            block.type === BlockType.SYNC_CONTAINER
              ? t('components.unsync.unsync_warning', { count: node.dataset.syncCount })
              : ' ',
          confirmText: t('common.unsync'),
          cancelText: t('components.unsync.think_again'),
          confirm,
        });
      }
    },
    [openModal, pageId, t]
  );
};

/** 只有源同步块才需要弹 */
export const useOpenDeleteSyncBlockDialog = () => {
  const openModal = useOpenModal();
  const { t } = useAppTranslation();
  return useCallback(
    (onlyOne: boolean, confirm: () => void) => {
      const text = onlyOne ? '1' : t('components.unsync.many');
      const content = t('components.unsync.delete_sync_block_warning', { count: text });
      openModal.warning({
        title: <div className="w-[338px]">{t('components.unsync.confirm_delete')}</div>,
        content,
        confirmText: t('components.unsync.delete_all'),
        cancelText: t('common.cancel'),
        confirm,
      });
    },
    [openModal, t]
  );
};
